import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { selectCurrentUser } from "../../redux/user/user.selectors";
import { sessionExpired } from "../../redux/user/user.actions";
import { authFetch, getApiUrl, SessionExpiredError } from "../../utils/api";

const PaViewLink = ({ policyId, className, children }) => {
    const currentUser = useSelector(selectCurrentUser);
    const dispatch = useDispatch();
    const [isOpening, setIsOpening] = useState(false);

    const handleClick = async () => {
        if (isOpening) return;
        setIsOpening(true);

        const tab = window.open("", "_blank");
        try {
            const response = await authFetch(
                `${getApiUrl()}/sso/paview`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ policyId }),
                },
                {
                    currentUser,
                    onSessionExpired: () => dispatch(sessionExpired()),
                }
            );
            if (!response.ok) {
                throw new Error(`mint failed: ${response.status}`);
            }
            const res = await response.json();
            if (tab) {
                tab.location.href = res.url;
            } else {
                window.location.href = res.url;
            }
        } catch (e) {
            if (tab) tab.close();
            if (!(e instanceof SessionExpiredError)) {
                toast.error("Could not open the Plan Admin portal");
            }
        } finally {
            setIsOpening(false);
        }
    };

    return (
        <button type="button" onClick={handleClick} disabled={isOpening} className={className}>
            {children}
        </button>
    );
};

export default PaViewLink;
